import React, {
	useContext,
	useEffect,
	useState
} from 'react';
import triangle from "../imgs/triangle.svg";
import WaitListToggle from "../contexts/WaitListToggle";
import ChartContext from "../contexts/ChartContext";
import CopierContext from "../contexts/CopierContext";
import SearchContext from "../contexts/SearchContext";
import InfoContext from "../contexts/InfoContext";
import { display_loader } from "../utils/loader-utils";
import wait from "../imgs/wait.svg"
import BruceModeContext from '../contexts/BruceModeContext';

const FunctionSwitch = () => {

	const [waitList, setWaitList] = useContext(WaitListToggle);
	const [chart,] = useContext(ChartContext);
	const [, setCopier] = useContext(CopierContext);
	const [,] = useContext(SearchContext);
	const [info, setInfo] = useContext(InfoContext);
	const [toggleClass, setToggleClass] = useState("");
	const [hideClass, setHideClass] = useState("hide-functions");
	const [,] = useState("");
	const [,] = useState(false);

	const [bM, setBM] = useContext(BruceModeContext);

	return (
		<div id="function-switch">
			<img className={`${bM.isBruce ? "black-filter" : ""}`} src={wait} onClick={(e) => {
				setWaitList(!waitList)
			}} alt="triangle" />
		</div>
	);
};

export default FunctionSwitch;
